import styled from 'styled-components';
import { media } from '@sizeid/commons/utils/styles';

export default styled.img`
  z-index: 2;
  position: absolute;
  bottom: -70px;
  width: 120px;
  left: 50%;
  margin-left: -60px;

  ${media.moreThan('sm')`
    bottom: -140px;
  `};

  ${media.moreThan('md')`
    width: 200px;
    margin-left: -100px;
  `};
`;
